const QUEUE_KEY = 'plc_offline_queue';

// Listeners for queue changes
const listeners = new Set();

function notifyListeners() {
  const queue = getQueue();
  listeners.forEach((fn) => fn(queue));
}

export function onQueueChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function getQueue() {
  try {
    return JSON.parse(localStorage.getItem(QUEUE_KEY) || '[]');
  } catch {
    return [];
  }
}

function saveQueue(queue) {
  localStorage.setItem(QUEUE_KEY, JSON.stringify(queue));
  notifyListeners();
}

export function addToQueue(entry) {
  const queue = getQueue();
  queue.push({
    id: Date.now() + '_' + Math.random().toString(36).slice(2, 7),
    timestamp: new Date().toISOString(),
    ...entry,
  });
  saveQueue(queue);
}

export function removeFromQueue(id) {
  const queue = getQueue().filter((e) => e.id !== id);
  saveQueue(queue);
}

export function clearQueue() {
  saveQueue([]);
}

// Replay all queued requests via the given axios instance
export async function replayQueue(api) {
  const queue = getQueue();
  if (queue.length === 0) return { synced: 0, failed: 0 };

  let synced = 0;
  let failed = 0;

  for (const entry of queue) {
    try {
      await api.request({
        method: entry.method,
        url: entry.url,
        data: entry.data,
        headers: entry.headers,
      });
      removeFromQueue(entry.id);
      synced++;
    } catch (err) {
      // If it's a server error (not network), remove it – it won't succeed on retry
      if (err.response && err.response.status < 500) {
        removeFromQueue(entry.id);
        failed++;
      } else {
        // Network still down – stop replaying
        break;
      }
    }
  }

  return { synced, failed };
}
